/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import store from "../../store/index";
import baseinput from "../../custom_lib/dynamic_forms/form_elements/baseinput.vue";
import baseselect from "../../custom_lib/dynamic_forms/form_elements/baseselect";
import basedate from "../../custom_lib/dynamic_forms/form_elements/basedate";
import basedatetime from "../../custom_lib/dynamic_forms/form_elements/basedatetime";
import basenumber from "../../custom_lib/dynamic_forms/form_elements/basenumber";
import basecheckbox from "../../custom_lib/dynamic_forms/form_elements/basecheckbox";
import baseradiogroup from "../../custom_lib/dynamic_forms/form_elements/baseradiogroup";
import basetime from "../../custom_lib/dynamic_forms/form_elements/basetime.vue";
import customModal from "../customModal/customModal.vue";
import moment from "moment";

export default {
  name: "crfview",
  components: {
    customModal,
    baseinput,
    baseselect,
    basedate,
    basedatetime,
    basenumber,
    basecheckbox,
    baseradiogroup,
    basetime,
  },
  props: {
    crfid: { type: String, default: "" },
    formId: { type: String, default: "" },
  },
  async mounted() {
    this.formsid = this.formId; // mirror
    this.defaultdate = localStorage.getItem("dateformat");
    this.defaultTime = localStorage.getItem("timeformat");
    await this.getuserIp();
    await this.getLanguageList();
    await this.getecrfdata();
    await this.getformdata();

    window.addEventListener("studyIdChanged", async () => {
      await this.getuserIp();
      await this.getecrfdata();
      await this.getformdata();
    });
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,

      novaluearray: ["summary", "subheader", "header", "notes", "description"],
      ecrfdata: {},
      crfdata: [],

      templatelist: [],
      selectedtemplate: "",
      languages: [],
      translatedtemplate: [],
      iPaddress: "",

      // legacy edit popup bindings
      selectedpageno: "",
      fieldname: "",
      fieldvalue: "",
      feildIdentifier: 0,
      editpopup: false,
      inputElements: [
        "color","email","file","hidden","month","number","password","range",
        "search","tel","text","url","week","boxed","textbox",
      ],
      inputtype: "text",
      fieldlabel: "",
      validatevalidationarray: [],
      optionsforvalue: [],

      // Data Verification modal model
      roleprivileges: [
        "Data Verification Open queries",
        "Data Verification Closed queries",
        "Data Verification Validate",
        "Data Verification Incorrect",
        "Data Verification Field query",
      ],
      openQueryCount: 0,
      closeQueryCount: 0,
      errormsg: {},

      modelelement: {},      // full field object
      modelname: "",         // fieldName
      modeltype: "text",     // type
      modelvalue: "",        // value
      modelprivileges: "Edit",
      modelinputclass: "form-control",
      modelradioclass: "col-md-10 my-1",

      numberVal: null,
      dateVal: "",
      scalevlidatemin: 0,
      scalevalidatemax: 10,
      downloadedfilenames: {},
      fromArchive: "false",
      audit: [],
      modelcomments: "",
      modelpgno: "",

      // mirror id used by some code paths
      formsid: "",
      languages:[],
      sourceLanguage: "",
      targetLanguage: "",
      validatePayload: {},
      fromdata: { pages: [{ pageStatus: ""} ] },
      crfformdata: [],
      defaultdate: "",
      defaultTime: "",
    };
  },
  methods: {
    async onformsave() {
        this.pageSaveResult = [];
        this.fromdata.pages.forEach(async (item) => {
          this.pagesavefieldnames = [];
          item.field.forEach((subitem) => {
            if (subitem.fieldName.includes("header")) {
            } else {
              this.pagesavefieldnames.push(subitem.fieldName);
            }
          });

          await this.formsaveapicall(item.pageNo);
        });
    },
async formsaveapicall(pagenumber) {
      let data = {
        formId: this.formsid,
        pageno: pagenumber,
        dataSource: "Web Browser",
        sourceID: this.iPaddress,
        fieldnames: this.pagesavefieldnames,
      };

      const idtoken = store.getters.getIdToken;
      await axios
        .put(`${this.baseurl}/forms/forms/updatefieldsfrompagesave`, data, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
           alert(this.$t('navigations.form validated successfully'));
          this.pageSaveResult.push(true);
          this.getformdata();
        })
        .catch((err) => {
          console.log(err);
          this.pageSaveResult.push(false);
          alert(`page ${this.pageno} is not validated`);
        });
    },
    async onclosed() {
      this.$router.go(-1);
    },
    headderclass(type){
      console.log("type",type);
if(type == "header" || type == "subheader"){
  return "headderbg";
}
else{
  return "fieldheight";
}
    },
    async getaudit(pgno, fieldname) {
  const idtoken = store.getters.getIdToken;
  this.auditLoading = true;
  this.auditError = "";
  this.audit = [];

  try {
    const url =
      this.baseurl +
      "/forms/forms/getauditdata?formId=" +
      (this.formsid || this.formId) +
      "&pageNo=" +
      String(pgno) +
      "&FieldName=" +
      encodeURIComponent(fieldname);

    const res = await axios.get(url, {
      headers: {
        Authorization: "Bearer " + idtoken,
        "Content-Type": "application/json",
      },
    });

    // Expected shape: [{ fields: [...] }]
    var rows = [];
    if (res && res.data) {
      if (Array.isArray(res.data) && res.data.length > 0) {
        var first = res.data[0];
        if (first && Array.isArray(first.fields)) {
          rows = first.fields;
        }
      } else if (Array.isArray(res.data.fields)) {
        // sometimes APIs return an object directly
        rows = res.data.fields;
      }
    }

    // Normalize + add stable key for v-for
    this.audit = (rows || []).map(function (r, idx) {
      // Keep existing properties but ensure a _k key exists
      var item = Object.assign({}, r);
      item._k = (item.validatedDate || "") + "-" + (item.validatedTime || "") + "-" + idx;
      return item;
    });

    // If nothing came back, keep as empty array
    if (!Array.isArray(this.audit)) this.audit = [];
  } catch (err) {
    console.log("getaudit error:", err);
    this.auditError = "Failed to load audit history.";
    this.audit = [];
  } finally {
    this.auditLoading = false;
  }
},

    // ===== time/date format helpers (from validation array)
    gettimeformat(validation) {
      if (!Array.isArray(validation) || validation.length === 0) return "h:mm A";
      const timeFormatElement = validation.find(function (item) {
        return typeof item === "string" && item.indexOf("TIMEFORMAT") === 0;
      });
      if (timeFormatElement) {
        const match = timeFormatElement.match(/\(([^)]+)\)/);
        return match ? match[1] : "h:mm A";
      }
      return "h:mm A";
    },
    getdateformat(validation) {
      if (!Array.isArray(validation) || validation.length === 0) return "DD-MM-YYYY";
      const dateFormatElement = validation.find(function (item) {
        return typeof item === "string" && item.indexOf("DATEFORMAT") === 0;
      });
      if (dateFormatElement) {
        const match = dateFormatElement.match(/\(([^)]+)\)/);
        return match ? match[1].replace(/[a-z]/g, function (c) { return c.toUpperCase(); }) : "MM-DD-YYYY";
      }
      return "DD-MM-YYYY";
    },

    setoptions(options) {
      if (!Array.isArray(options)) return "";
      return options
        .map(function (o) { return (o && typeof o.optionname === "string") ? o.optionname.trim() : ""; })
        .filter(Boolean)
        .join(", ");
    },

    async getuserIp() {
      try {
        const res = await axios.get("https://api.ipify.org?format=json");
        this.iPaddress = res.data.ip;
      } catch (e) {
        this.iPaddress = "0.0.0.0";
      }
    },

    Closeeditmodel() {
      this.editpopup = false;
    },

    gevalue(fielddata) {
      if (!fielddata) return "";
      var options = Array.isArray(fielddata.options) ? fielddata.options : [];

      function pickDefined() {
        for (var i = 0; i < arguments.length; i++) {
          var v = arguments[i];
          if (v !== undefined && v !== null && v !== "") return v;
        }
        return "";
      }

      function getLabel(v) {
        var match = null;
        for (var i = 0; i < options.length; i++) {
          if (String(options[i].codevalue) === String(v)) {
            match = options[i];
            break;
          }
        }
        if (match) {
          var label = pickDefined(match.optionname, match.label, match.name);
          return label !== "" ? label : v;
        }
        return v;
      }

      return Array.isArray(fielddata.value)
        ? fielddata.value.map(getLabel).join(", ")
        : getLabel(fielddata.value);
    },

    // open modal and hydrate fields
    async editfieldfun(valuepassed) {
      // legacy
      this.fieldvalue = valuepassed.value;
      this.fieldlabel = valuepassed.label;
      this.selectedpageno = valuepassed.pageNo;
      this.feildIdentifier = 0;
      this.fieldname = valuepassed.fieldName;
      this.inputtype = valuepassed.type;
      this.optionsforvalue = valuepassed.options || [];
      this.validatevalidationarray = valuepassed.validation || [];

      // modal aliases
      this.modelelement = valuepassed;
      this.modelname = valuepassed.fieldName;
      this.modeltype = valuepassed.type;
      this.modelvalue = Array.isArray(valuepassed.value) ? valuepassed.value.slice() : valuepassed.value;

      var pg = (valuepassed && valuepassed.pageNo != null) ? String(valuepassed.pageNo) :
               (this.selectedpageno != null ? String(this.selectedpageno) : "");
      this.modelpgno = pg;
      await this.getaudit(this.modelpgno, this.modelname);
      // privileges
      var status = (this.fromdata && this.fromdata.status) ? this.fromdata.status : "";
      this.modelprivileges = (status === "Approved" || status === "Rejected") ? "View" : "Edit";

      if (!this.errormsg[this.modelname]) this.errormsg[this.modelname] = "";
      this.editpopup = true;
    },

    // legacy basic save
    async editvalue() {
      const idtoken = store.getters.getIdToken;
      const data = {
        formId: this.formId,
        pageNo: String(this.selectedpageno || this.modelpgno || ""),
        dataSource: "Web Browser",
        sourceID: this.iPaddress,
        updateFieldDTO: {
          fieldName: this.fieldname,
          value: this.fieldvalue ? this.fieldvalue.toString() : "",
          status: "",
          comment: "",
          fieldIdentifier: this.feildIdentifier || 0,
          repeatedFieldName: "",
          visibility: true,
        },
      };
      try {
        await axios.put(`${this.baseurl}/forms/forms/updatefeild`, data, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
      } catch (err) {
        console.log(err);
      }
      await this.getecrfdata();
      await this.getformdata();
      this.editpopup = false;
    },

    // fetchers
    async getecrfdata() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/ecrfsource/getbyecrfid/${this.crfid}`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.ecrfdata = res.data;
        this.crfdata = this.makecrfdata();
        this.sourceLanguage = await this.mapLanguageCode(this.ecrfdata.sourceLanguage);
      } catch (err) {
        console.log("error in ecrf get", err);
      }
    },
    async getformdata() {
      const idtoken = store.getters.getIdToken;
      try {
        const res = await axios.get(
          `${this.baseurl}/forms/forms/getbyid/${this.formId}?api-version=1`,
          { headers: { Authorization: "Bearer " + idtoken, "Content-Type": "application/json" } }
        );
        this.fromdata = res.data;
        this.crfformdata = this.makecrfformdata();
        this.targetLanguage = await this.mapLanguageCode(this.fromdata.language);
      } catch (err) {
        console.log("error in form get", err);
      }
    },

    makecrfdata() {
      if (!this.ecrfdata || !Array.isArray(this.ecrfdata.pages)) return [];
      return this.ecrfdata.pages.flatMap(function (p) {
        const fields = Array.isArray(p.field) ? p.field : [];
        return fields.map(function (f, idx) {
          return {
            ...f,
            pageName: p.pageName,
            pageNo: p.pageNo,
            indexOnPage: idx,
          };
        });
      });
    },
    makecrfformdata() {
      if (!this.fromdata || !Array.isArray(this.fromdata.pages)) return [];
      return this.fromdata.pages.flatMap(function (p) {
        const fields = Array.isArray(p.field) ? p.field : [];
        return fields.map(function (f, idx) {
          return {
            ...f,
            pageName: p.pageName,
            pageNo: p.pageNo,
            indexOnPage: idx,
          };
        });
      });
    },

    // ===== Save/Validate/Incorrect (no validation)
    async saveaudit(status, type) {
      var effectiveType = type || this.modeltype;
      if (effectiveType === "numberanddate") {
        this.modelvalue = this.formatDateNum(this.dateVal) + "_" + (this.numberVal != null ? this.numberVal : "");
      }
      if (effectiveType === "dateandtime") {
        this.modelvalue = this.formatDateTime(this.modelvalue);
      }
      await this.setaudit(status);
    },

    async saveOnly() {
      await this.setaudit("");
    },

    async setaudit(status) {
      const idtoken = store.getters.getIdToken;

      const formId = this.formsid || this.formId;
      const pageNo = String(this.modelpgno || this.selectedpageno || "");
      const isRepeating = !!this.isModelRepeating;
      const fieldName = isRepeating
        ? (this.repeatingFeildName || this.modelname)
        : this.modelname;
      const repeatedFieldName = isRepeating ? this.modelname : "";

      const payload = {
        formId: formId,
        pageNo: pageNo,
        dataSource: "Web Browser",
        sourceID: this.iPaddress,
        updateFieldDTO: {
          fieldName: fieldName,
          value: this.modelvalue != null ? this.modelvalue.toString() : "",
          status: status || "", // '' | 'Validated' | 'Incorrect'
          comment: this.modelcomments || "",
          fieldIdentifier: this.feildIdentifier || 0,
          repeatedFieldName: repeatedFieldName,
          visibility: true,
        },
      };

      try {
        await axios.put(`${this.baseurl}/forms/forms/updatefeild`, payload, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });

        // local UI update
        this._updateLocalFormValue({
          pageNo: pageNo,
          fieldName: fieldName,
          value: payload.updateFieldDTO.value,
          isRepeating: isRepeating,
          repeatedFieldName: repeatedFieldName,
          fieldIdentifier: this.feildIdentifier || 0,
        });

        // local audit row
        const now = new Date();
        const uname =
          (store && store.getters && store.getters.getUserName) ? store.getters.getUserName : "";
        this.audit.unshift({
          _k: String(now.getTime()) + "-" + String(Math.random()),
          newValue: payload.updateFieldDTO.value,
          status: status || "Saved",
          validatedBy: uname,
          dataSource: "Web Browser",
          validatedDate: now.toISOString().slice(0, 10),
          validatedTime: now.toTimeString().slice(0, 8),
          comment: this.modelcomments || "",
        });

        // refetch to stay consistent
        if (typeof this.getecrfdata === "function") await this.getecrfdata();
        if (typeof this.getformdata === "function") await this.getformdata();

        // close
        this.Closeeditmodel();
        try { await this.getaudit(pageNo, fieldName); } catch (e) {}
      } catch (err) {
        console.error("updatefeild error:", err);
      }
    },

    _updateLocalFormValue(opts) {
      var pageNo = opts.pageNo;
      var fieldName = opts.fieldName;
      var value = opts.value;
      var isRepeating = opts.isRepeating;
      var repeatedFieldName = opts.repeatedFieldName;
      var fieldIdentifier = opts.fieldIdentifier;

      try {
        if (this.fromdata && Array.isArray(this.fromdata.pages)) {
          var pg = this.fromdata.pages.find(function (p) { return String(p.pageNo) === String(pageNo); });
          if (pg && Array.isArray(pg.field)) {
            if (isRepeating) {
              var rf = pg.field.find(function (f) { return f.fieldName === repeatedFieldName; });
              if (rf && Array.isArray(rf.value)) {
                rf.value[fieldIdentifier] = value;
              } else if (rf) {
                rf.value = value;
              }
            } else {
              var f = pg.field.find(function (f) { return f.fieldName === fieldName; });
              if (f) f.value = value;
            }
          }
          this.crfformdata = this.makecrfformdata() || this.crfformdata;
        }

        if (this.ecrfdata && Array.isArray(this.ecrfdata.pages)) {
          var epg = this.ecrfdata.pages.find(function (p) { return String(p.pageNo) === String(pageNo); });
          if (epg && Array.isArray(epg.field)) {
            var ef = epg.field.find(function (f) { return f.fieldName === fieldName; });
            if (ef) ef.value = value;
          }
          this.crfdata = this.makecrfdata() || this.crfdata;
        }
      } catch (e) {
        console.warn("local form update failed; relying on refetch", e);
      }
    },

    // formatting + misc
    formatDateNum(d) {
      if (!d) return "";
      const parts = String(d).split("-");
      if (parts.length !== 3) return String(d);
      return [parts[2], parts[1], parts[0]].join("-");
    },
    formatDateTime(val) {
      if (!val) return "";
      if (typeof val === "string" && val.indexOf("T") !== -1) return val;
      try {
        const dt = new Date(val);
        const pad = function (n) { return String(n).padStart(2, "0"); };
        return (
          dt.getFullYear() + "-" +
          pad(dt.getMonth() + 1) + "-" +
          pad(dt.getDate()) + "T" +
          pad(dt.getHours()) + ":" +
          pad(dt.getMinutes())
        );
      } catch (e) {
        return String(val);
      }
    },
    filter(data) {
      if (data) {
          return moment(data).format(this.defaultdate)
      }
    },
   filterTime(time) {
      if(time){
        return moment(time).format(this.defaultTime)
      }
    },
    helloButton(e) {
      const file = e && e.target && e.target.files && e.target.files[0];
      if (file && this.modelelement && this.modelelement.fieldName) {
        this.downloadedfilenames[this.modelelement.fieldName] = file.name;
      }
    },

    FieldQueryDetails(state) {
      console.log("Query details clicked:", state);
    },
    gotoraiseQuary(kind) {
      console.log("Raise query:", kind, this.modelname);
    },

    async setformid() {
      this.formsid = this.formId;
    },
    async getLanguageList(){
      const idtoken = store.getters.getIdToken;
      await axios.get(this.baseurl + "/forms/template/languages",
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        this.languages = res.data;
      }).catch((err) => {
        console.log("error in fetching languages", err);
      });
    },
    async mapLanguageCode(langcode) {
        const match = this.languages.find(l => l.code.toLowerCase() === langcode.toLowerCase());

        if (match) {
           return match.language; 
        } 
        else { 
          return null; 
        }
    },
    async validateform(){
      const idtoken = store.getters.getIdToken;
      try {
        await axios.put(  
          `${this.baseurl}/forms/forms/updatefieldsfrompagesave`,this.validatePayload,
          {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        });
      } catch (err) {
        console.log("error in form validate", err);
      }
    },
    mapValidatePayload(){
      this.validatePayload = {
        "formId": this.formsid,
        "pageno": 0,
        "dataSource": "Web Browser",
        "sourceID": "string",
        "fieldnames": ["string"]
      };
    }
  },
};
